module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_eight@3x-5c2593516206c9c1b13f0236ffa07f32.webp";